import { Vehicle, Booking, VehicleType, City, MaintenancePeriod } from './types';

export function generateMockVehicles(): Vehicle[] {

  return Array.from({ length: 5 }, (_, i) => ({
    id: `${i + 1}`,
    vehicleNumber: `MH-12-${String.fromCharCode(65 + Math.floor(i / 4))}-${1000 + i * 111}`,
    vehicleType: 'Maruti Suzuki Dzire', // Default type for all vehicles; can be randomized if needed
    driverName: 'Piyush Kumar',
    currentCity: 'Pune',
    currentLocation: 'Kothrud'
  }));
}

export function generateMockBookings(): Booking[] {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const bookings: Booking[] = [];
  
  // ============= DAY -2 (2 days before today - visible at start of timeline) =============
  
  // Vehicle 1 (Maruti Suzuki Dzire): Pune to Mumbai one-way trip (5 hours)
  bookings.push({
    id: 'B001',
    vehicleId: '1',
    startTime: new Date(today.getTime() + (-2 * 24 + 7) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (-2 * 24 + 12) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Pune',
    dropCity: 'Mumbai',
    pickupLocation: 'Kothrud',
    dropLocation: 'Mumbai Airport',
    bookingId: '#4501',
    description: 'Pune → Mumbai Airport (One Way)'
  });
  
  // Vehicle 2 (Toyota Rumion S): Mumbai local 9h package
  bookings.push({
    id: 'B002',
    vehicleId: '2',
    startTime: new Date(today.getTime() + (-2 * 24 + 8) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (-2 * 24 + 17) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Mumbai',
    dropCity: 'Mumbai',
    pickupLocation: 'Andheri',
    dropLocation: 'Andheri',
    bookingId: '#4502',
    description: 'Mumbai Local – 9h Package'
  });
  
  // Vehicle 3 (Kia Carens Premium): Mumbai to Pune (5 hours)
  bookings.push({
    id: 'B004',
    vehicleId: '3',
    startTime: new Date(today.getTime() + (-1 * 24 + 9) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (-1 * 24 + 14) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Mumbai',
    dropCity: 'Pune',
    pickupLocation: 'Bandra',
    dropLocation: 'Hinjewadi',
    bookingId: '#4504',
    description: 'Mumbai → Pune (One Way)'
  });
  
  // Vehicle 4 (Toyota Crysta GX 7 STR): Pune local 12h package
  bookings.push({
    id: 'B005',
    vehicleId: '3',
    startTime: new Date(today.getTime() + (-1 * 24 + 7) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (-1 * 24 + 19) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Pune',
    dropCity: 'Pune',
    pickupLocation: 'Koregaon Park',
    dropLocation: 'Koregaon Park',
    bookingId: '#4505',
    description: 'Pune Local – 12h Package'
  });
  
  
  // Vehicle 1 (Sedan): Mumbai to Pune (5 hours)
  bookings.push({
    id: 'B007',
    vehicleId: '1',
    startTime: new Date(today.getTime() + 8 * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + 13 * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Mumbai',
    dropCity: 'Pune',
    pickupLocation: 'Mumbai Airport',
    dropLocation: 'Kothrud',
    bookingId: '#4507',
    description: 'Mumbai → Pune (One Way)'
  });
  
  // Vehicle 2 (SUV-CNG): Pune to Mumbai (5 hours)
  bookings.push({
    id: 'B008',
    vehicleId: '2',
    startTime: new Date(today.getTime() + 6 * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + 11 * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Pune',
    dropCity: 'Mumbai',
    pickupLocation: 'Hinjewadi',
    dropLocation: 'Powai',
    bookingId: '#4508',
    description: 'Pune → Mumbai (One Way)'
  });
  
  // Vehicle 2: Mumbai local 6h package
  bookings.push({
    id: 'B009',
    vehicleId: '2',
    startTime: new Date(today.getTime() + 14 * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + 20 * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Mumbai',
    dropCity: 'Mumbai',
    pickupLocation: 'Powai',
    dropLocation: 'Powai',
    bookingId: '#4509',
    description: 'Mumbai Local – 6h Package'
  });
  
  // Vehicle 3 (SUV-Diesel): Pune local 9h package
  bookings.push({
    id: 'B010',
    vehicleId: '3',
    startTime: new Date(today.getTime() + 9 * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + 18 * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Pune',
    dropCity: 'Pune',
    pickupLocation: 'Baner',
    dropLocation: 'Baner',
    bookingId: '#4510',
    description: 'Pune Local – 9h Package'
  });
  
  // Vehicle 4 (Premium SUV): Pune to Mumbai Airport (5 hours)
  bookings.push({
    id: 'B011',
    vehicleId: '4',
    startTime: new Date(today.getTime() + 10 * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + 15 * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Pune',
    dropCity: 'Mumbai',
    pickupLocation: 'Koregaon Park',
    dropLocation: 'Mumbai Airport',
    bookingId: '#4511',
    description: 'Pune → Mumbai Airport (One Way)'
  });
  
  // Vehicle 5 (Sedan): Pune local 12h package
  bookings.push({
    id: 'B012',
    vehicleId: '5',
    startTime: new Date(today.getTime() + 7 * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + 19 * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Pune',
    dropCity: 'Pune',
    pickupLocation: 'Camp',
    dropLocation: 'Camp',
    bookingId: '#4512',
    description: 'Pune Local – 12h Package'
  });
  
  // ============= DAY 1 =============
  
  // Vehicle 1 (Sedan): Pune to Mumbai (6 hours)
  bookings.push({
    id: 'B016',
    vehicleId: '1',
    startTime: new Date(today.getTime() + (24 + 9) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (24 + 14) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Pune',
    dropCity: 'Mumbai',
    pickupLocation: 'Shivajinagar',
    dropLocation: 'Bandra',
    bookingId: '#4516',
    description: 'Pune → Mumbai (One Way)'
  });
  
  // Vehicle 2 (SUV-CNG): Pune local 9h package
  bookings.push({
    id: 'B017',
    vehicleId: '2',
    startTime: new Date(today.getTime() + (24 + 8) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (24 + 17) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Pune',
    dropCity: 'Pune',
    pickupLocation: 'Aundh',
    dropLocation: 'Aundh',
    bookingId: '#4517',
    description: 'Pune Local – 9h Package'
  });
  
  // Vehicle 3 (SUV-Diesel): Mumbai to Pune (5 hours)
  bookings.push({
    id: 'B018',
    vehicleId: '3',
    startTime: new Date(today.getTime() + (24 + 7) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (24 + 12) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Mumbai',
    dropCity: 'Pune',
    pickupLocation: 'Colaba',
    dropLocation: 'Wakad',
    bookingId: '#4518',
    description: 'Mumbai → Pune (One Way)'
  });
  
  // Vehicle 4 (Premium SUV): Mumbai local 12h package
  bookings.push({
    id: 'B019',
    vehicleId: '4',
    startTime: new Date(today.getTime() + (24 + 10) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (24 + 22) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Mumbai',
    dropCity: 'Mumbai',
    pickupLocation: 'Juhu',
    dropLocation: 'Juhu',
    bookingId: '#4519',
    description: 'Mumbai Local – 12h Package'
  });
  
  // ============= DAY 2 =============
  
  // Vehicle 1 (Sedan): Mumbai to Pune (5 hours)
  bookings.push({
    id: 'B020',
    vehicleId: '1',
    startTime: new Date(today.getTime() + (2 * 24 + 8) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (2 * 24 + 13) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Mumbai',
    dropCity: 'Pune',
    pickupLocation: 'Dadar',
    dropLocation: 'Kharadi',
    bookingId: '#4520',
    description: 'Mumbai → Pune (One Way)'
  });
  
  // Vehicle 2 (SUV-CNG): Pune to Mumbai Airport (6 hours)
  bookings.push({
    id: 'B021',
    vehicleId: '2',
    startTime: new Date(today.getTime() + (2 * 24 + 5) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (2 * 24 + 10) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Pune',
    dropCity: 'Mumbai',
    pickupLocation: 'Magarpatta',
    dropLocation: 'Mumbai Airport',
    bookingId: '#4521',
    description: 'Pune → Mumbai Airport (One Way)'
  });
  
  // Vehicle 5 (Sedan): Pune local 6h package
  bookings.push({
    id: 'B022',
    vehicleId: '5',
    startTime: new Date(today.getTime() + (2 * 24 + 9) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (2 * 24 + 15) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Pune',
    dropCity: 'Pune',
    pickupLocation: 'Baner',
    dropLocation: 'Baner',
    bookingId: '#4522',
    description: 'Pune Local – 6h Package'
  });
  
  // Vehicle 3 (SUV-Diesel): Pune to Mumbai (5 hours)
  bookings.push({
    id: 'B024',
    vehicleId: '3',
    startTime: new Date(today.getTime() + (3 * 24 + 10) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (3 * 24 + 15) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Pune',
    dropCity: 'Mumbai',
    pickupLocation: 'Hadapsar',
    dropLocation: 'Navi Mumbai',
    bookingId: '#4524',
    description: 'Pune → Navi Mumbai (One Way)'
  });
  
  // Vehicle 4 (Premium SUV): Mumbai local 9h package
  bookings.push({
    id: 'B025',
    vehicleId:'4',
    startTime: new Date(today.getTime() + (3 * 24 + 8) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (3 * 24 + 17) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Mumbai',
    dropCity: 'Mumbai',
    pickupLocation: 'Goregaon',
    dropLocation: 'Goregaon',
    bookingId: '#4525',
    description: 'Mumbai Local – 9h Package'
  });
  
  // Vehicle 5 (Sedan): Pune local 12h package
  bookings.push({
    id: 'B026',
    vehicleId: '5',
    startTime: new Date(today.getTime() + (3 * 24 + 6) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (3 * 24 + 18) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Pune',
    dropCity: 'Pune',
    pickupLocation: 'Pimpri',
    dropLocation: 'Pimpri',
    bookingId: '#4526',
    description: 'Pune Local – 12h Package'
  });
  
  // ============= DAY 4 =============
  
  // Vehicle 1 (Sedan): Pune to Mumbai Airport (5 hours)
  bookings.push({
    id: 'B027',
    vehicleId: '1',
    startTime: new Date(today.getTime() + (4 * 24 + 5) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (4 * 24 + 10) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Pune',
    dropCity: 'Mumbai',
    pickupLocation: 'Viman Nagar',
    dropLocation: 'Mumbai Airport',
    bookingId: '#4527',
    description: 'Pune → Mumbai Airport (One Way)'
  });
  
  // Vehicle 1 (Sedan): Mumbai to Pune (5 hours)
  bookings.push({
    id: 'B030',
    vehicleId: '1',
    startTime: new Date(today.getTime() + (7 * 24 + 9) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (7 * 24 + 14) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Mumbai',
    dropCity: 'Pune',
    pickupLocation: 'Kurla',
    dropLocation: 'Hinjewadi',
    bookingId: '#4530',
    description: 'Mumbai → Pune (One Way)'
  });
  
  // Vehicle 2 (SUV-CNG): Pune local 9h package
  bookings.push({
    id: 'B031',
    vehicleId: '2',
    startTime: new Date(today.getTime() + (7 * 24 + 8) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (7 * 24 + 17) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Pune',
    dropCity: 'Pune',
    pickupLocation: 'Katraj',
    dropLocation: 'Katraj',
    bookingId: '#4531',
    description: 'Pune Local – 9h Package'
  });
  
  // Vehicle 3 (SUV-Diesel): Mumbai to Pune (5 hours)
  bookings.push({
    id: 'B033',
    vehicleId: '3',
    startTime: new Date(today.getTime() + (8 * 24 + 7) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (8 * 24 + 12) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Mumbai',
    dropCity: 'Pune',
    pickupLocation: 'Malad',
    dropLocation: 'Wakad',
    bookingId: '#4533',
    description: 'Mumbai → Pune (One Way)'
  });
  
  // Vehicle 4 (Premium SUV): Mumbai local 6h package
  bookings.push({
    id: 'B034',
    vehicleId: '4',
    startTime: new Date(today.getTime() + (8 * 24 + 10) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (8 * 24 + 16) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Mumbai',
    dropCity: 'Mumbai',
    pickupLocation: 'Churchgate',
    dropLocation: 'Churchgate',
    bookingId: '#4534',
    description: 'Mumbai Local – 6h Package'
  });
  
  // Vehicle 1 (Sedan): Pune to Mumbai Airport (5 hours)
  bookings.push({
    id: 'B036',
    vehicleId: '1',
    startTime: new Date(today.getTime() + (10 * 24 + 6) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (10 * 24 + 11) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Pune',
    dropCity: 'Mumbai',
    pickupLocation: 'Kondhwa',
    dropLocation: 'Mumbai Airport',
    bookingId: '#4536',
    description: 'Pune → Mumbai Airport (One Way)'
  });
  
  // Vehicle 5 (Sedan): Pune local 12h package
  bookings.push({
    id: 'B037',
    vehicleId: '5',
    startTime: new Date(today.getTime() + (10 * 24 + 7) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (10 * 24 + 19) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Pune',
    dropCity: 'Pune',
    pickupLocation: 'Warje',
    dropLocation: 'Warje',
    bookingId: '#4537',
    description: 'Pune Local – 12h Package'
  });
  
  // Vehicle 2 (SUV-CNG): Pune to Mumbai (5 hours)
  bookings.push({
    id: 'B041',
    vehicleId: '2',
    startTime: new Date(today.getTime() + (13 * 24 + 9) * 60 * 60 * 1000),
    endTime: new Date(today.getTime() + (13 * 24 + 14) * 60 * 60 * 1000),
    status: 'confirmed',
    pickupCity: 'Pune',
    dropCity: 'Mumbai',
    pickupLocation: 'Karve Nagar',
    dropLocation: 'Fort',
    bookingId: '#4541',
    description: 'Pune → Mumbai (One Way)'
  });
  
  return bookings;
}

export function generateMockMaintenancePeriods(vehicles: Vehicle[]): MaintenancePeriod[] {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const maintenancePeriods: MaintenancePeriod[] = [];
  
  return maintenancePeriods;
}